import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/backend'
  }, {
    path: '/backend',
    redirect: '/backend/home'
  }, {
    path: '/backend/login',
    name: 'backendLogin',
    component: () => import('../pagesC/loginPage.vue')
  }, {
    path: '/backend',
    component: () => import('../pagesC/backApp.vue'),
    children: [
      {
        path: '/backend/home',
        name: 'backhome',
        component: () => import('../pagesC/homePage.vue')
      }, {
        path: '/backend/comps',
        name: 'backcomps',
        component: () => import('../pagesC/compsPage.vue')
      }, {
        path: '/backend/compReg',
        name: 'backcompReg',
        component: () => import('../pagesC/comp/compReg.vue')
      }, {
        path: '/backend/compGrade',
        name: 'backcompGrade',
        component: () => import('../pagesC/comp/compGrade.vue')
      }, {
        path: '/backend/actives',
        name: 'backactives',
        component: () => import('../pagesC/activesPage.vue')
      }, {
        path: '/backend/activeReg',
        name: 'backactiveReg',
        component: () => import('../pagesC/active/activeReg.vue')
      }, {
        path: '/admin/web',
        name: 'backweb',
        component: () => import('../pagesC/webPage.vue')
      }, {
        path: '/admin/notices',
        name: 'backnotices',
        component: () => import('../pagesC/noticesPage.vue')
      }, {
        path: '/admin/users',
        name: 'backusers',
        component: () => import('../pagesC/usersPage.vue')
      }, {
        path: '/admin/events',
        name: 'backevents',
        component: () => import('../pagesC/eventsPage.vue')
      }, {
        path: '/admin/logs',
        name: 'backlogs',
        component: () => import('../pagesC/logsPage.vue')
      }, {
        path: '/admin/flows',
        name: 'backflows',
        component: () => import('../pagesC/flowsPage.vue')
      }, {
        path: '/admin/others',
        name: 'backothers',
        component: () => import('../pagesC/othersPage.vue')
      }, 
    ]
  }
];

var router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;